import { useTranslations } from '@vocab/react';
import { Stack, Alert, Text } from 'braid-design-system';
import { format } from 'date-fns';
import translations from './.vocab';

export const CurrentPricesDisclaimer = ({
  showDiscountedPrice,
}: {
  showDiscountedPrice: boolean;
}) => {
  const { t } = useTranslations(translations);

  const currentDate = format(Date.now(), 'd/M/yyyy');

  return (
    <Stack space={'small'}>
      <Text tone="secondary" size="standard">
        {t('*Current prices as at currentDate and are subject to change', {
          currentDate,
        })}
      </Text>
      {showDiscountedPrice && (
        <Alert tone="info">
          <Text>{t('All prices reflect your current...')}</Text>
        </Alert>
      )}
    </Stack>
  );
};
